import { ReactNode } from 'react'

type ToolbarSectionHeaderProps = {
  icon?: ReactNode
  title: string
}

export const ToolbeltSectionHeader = ({ icon, title }: ToolbarSectionHeaderProps) => {
  return (
    <div className="w-full uppercase text-[10px] flex flex-col gap-1 justify-center items-center text-zinc-400">
      {icon}
      <span>{title}</span>
    </div>
  )
}
